import {GetterTree} from 'vuex'
import {StatisticState} from './types';
import {RootState} from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
    smsStatisticDetail: state => state.smsStatisticDetail,
    smsStatisticDetailIncoming: state => state.smsStatisticDetailIncoming,
    smsStatisticGroup: state => state.smsStatisticGroup,
    smsStatisticGroupIncoming: state => state.smsStatisticGroupIncoming,
    smsGroupBy: state => state.smsGroupings.smsGroup,
    smsGroupByOptionally: state => state.smsGroupings.smsGroupOptionally,
};
